import { createFileRoute } from "@tanstack/react-router";

import { AuditLogPage } from "@/components/audit/AuditLogPage";
import { requireFeature, requirePermission } from "@/lib/feature-gate";

export const Route = createFileRoute("/admin/_layout/audit-log")({
  beforeLoad: async () => {
    requireFeature("audit");
    await requirePermission("audit.log.view");
  },
  component: () => <AuditLogPage scope="org" />,
});
